if ( ! window.console ) console = { log: function(){} };

var $header,
	$viewport;

$(document).ready(function(){
	
	
	$header = $('header#title');
	$viewport = $('#viewport');


	/**************************
	   BANNER REVOLUTION SLIDER
	**************************/

	 $('#rev_slider_banner').show().revolution({
		jsFileLocation:"/assets/lib/revolution/js/",
		sliderType:"carousel",
		sliderLayout:"fullwidth",
		dottedOverlay:"none",
		delay:9000,
		navigation: {
			arrows: {
				enable: true,
				style: 'none',
				space: 5,
				hide_onmobile:true,
				hide_under:600,
				hide_onleave:true,
				hide_delay:200,
				hide_delay_mobile:1200,
			},
			keyboardNavigation:"off",
			keyboard_direction: "horizontal",
			mouseScrollNavigation:"off",
			mouseScrollReverse:"default",
			onHoverStop:"off",
		},
		carousel: {
			vary_rotation: "off",
			vary_scale: "off",
			horizontal_align: "center",
			vertical_align: "center",
			fadeout: "off",
			vary_fade: "off",
			maxVisibleItems: 3,
			infinity: "on",
			space: 0,
			stretch: "off",
			showLayersAllTime: "off",
			easing: "Power3.easeInOut",
			speed: "800"
		},
		responsiveLevels:[0,1400,1200,992,768],
		visibilityLevels:[0,1400,1200,992,768],
		gridwidth:[1200,1000,920,768],
		gridheight:[700,583,537,448],
		lazyType:"none",
		shadow:0,
		spinner:"off",
		stopLoop:"on",
		stopAfterLoops:0,
		stopAtSlide:1,
		shuffle:"off",
		autoHeight:"off",
		fullScreenAutoWidth:"off",
		fullScreenAlignForce:"off",
		fullScreenOffsetContainer: "",
		fullScreenOffset: "",
		disableProgressBar:"on",
		hideThumbsOnMobile:"off",
		hideSliderAtLimit:0,
		hideCaptionAtLimit:0,
		hideAllCaptionAtLilmit:0,
		debugMode:false,
		fallbacks: {
			simplifyAll:"off",
			nextSlideOnWindowFocus:"off",
			disableFocusListener:false,
		}

	});


	/************************************
	   GALLERY REVOLUTION SLIDER CAROUSEL
	************************************/
	
	var $gallery = $('#rev_slider_gallery');
	$gallery.show().revolution({
		jsFileLocation: "/assets/lib/revolution/js/",
		sliderType: 'carousel',
		stopLoop: 'on',
		stopAfterLoops: 0,
		stopAtSlide: 1,
		carousel: {
			space: 0,
			infinity: 'on',
			stretch: 'off',
			border_radius: '0',
			horizontal_align: 'center',
			fadeout: 'off',
			vary_fade: 'off',
			vary_rotation: 'off',
			maxRotation: 0,
			vary_scale: 'off',
			minScale: 0
		},
		navigation: {
			arrows: {
				enable: true,
				style: 'gyges',
				width: 100,
				height: 50,
				min_width: 100,
				space: 5,
				hide_onmobile:true,
				hide_under:600,
				hide_onleave:true,
				hide_delay:200,
				hide_delay_mobile:1200,
				left: {
					h_align:"left",
					v_align:"center",
					h_offset:20,
					v_offset:0
				},
				right: {
					h_align:"right",
					v_align:"center",
					h_offset:20,
					v_offset:0
				}
			},
			thumbnails: {
				style:"gyges",
				enable:true,
				width:130,
				height:80,
				min_width: 60,
				wrapper_padding:0,
				wrapper_color:"transparent",
				wrapper_opacity:"1",
				visibleAmount:8,
				hide_onmobile:true,
				hide_under:800,
				hide_onleave:false,
				direction:"horizontal",
				span:false,
				position:"outer-bottom",
				space:10,
				h_align:"center",
				v_align:"bottom",
				h_offset:0,
				v_offset:0
			}
		},
		gridwidth:1200,
		gridheight:700,
		disableProgressBar:"on",
		spinner:"on",
		shuffle:"off"
	});

	// Responsive Slider Images
	$('.rev_slider').find('img').each(function() {
		var $this = $(this),
			sizes = $this.data('sizes'),
			screen_w = $(window).width(),
			screen_d = 1;

		if(window.devicePixelRatio !== undefined) {
			screen_d = window.devicePixelRatio;
		}

		//console.log('Gallery Srcset:');
		//console.log('=> screen width: ' + screen_w);

		if (typeof this.currentSrc !== undefined) {
			//console.log('=> current src: ' + this.currentSrc);
			$this.attr('data-lazyload', this.currentSrc);
		} else {
			$.each(sizes, function(width, size){
				//console.log('=> comparing: ' + screen_w + ' <= ' + (width / screen_d));
				if(screen_w <= (width / screen_d)) {
					//console.log('=> loading ' + size + ' (' + width + '): ' + $this.data('srcset-' + size));
					$this.attr('data-lazyload', $this.data('srcset-' + size));
					return false;
				}
			});
		}
	});


	// Smooth Scroll to a certain element
	$('a[href*="#"]:not([href="#"])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top
					}, 400);
				return false;
			}
		}
	});

	// init Masonry for stories
	var $grid = $('.grid-masonry').masonry();

	// layout Masonry after each image loads to avoid overlapping images
	$grid.imagesLoaded().progress( function() {
		$grid.masonry('layout');
	});


	/* Show more blog article - Infinite Scroll */
	$('.grid-masonry').on('click', '.see-more a.load-more', function(e) {

		e.preventDefault();
		var href = $(this).attr("href");
		$.get(href, {}, function(data){
			$("div.see-more").remove();

			var $gridajax = $('.grid-masonry').append(data).masonry('reloadItems');

			// layout Masonry after each image loads to avoid overlapping images
			$gridajax.imagesLoaded( function() {
				$gridajax.masonry('layout');
			});

		});

	});




	/************************************
	   QUICK ACCESS
	************************************/
	
	var $page_body = $('div.page-body', $viewport),
		$quick_nav = $('nav#quick-access', $page_body);
	
	if ($quick_nav.length) {
		var $list = $('ul', $quick_nav),
			$h2s = $('h2', $page_body);
		
		var count = 0;
		
		// Loop all h2's in the main body, adding linked anchors for each.
		$h2s.each(function(index, h2){
			
			var $h2 = $(h2),
				id = $h2.attr('id');
			
			// Skip this header if it's the section title, or contained by the sidebar.
			if ($h2.parents('.section-title, .sidebar').length) {
				return;
			}
			
			// Validate an anchor id.
			if (id === undefined) {
				id = 'h2_' + index;
				$h2.attr('id', id);
			}
			
			// Add the title as a list item of quick links.
			$list.append('<li><a href="#'+id+'" title="'+$h2.text()+'">'+$h2.text()+'</a></li>');
			count++;
		});
		if(count>0 && $('a#menu-toggle').css('display') == 'none') $quick_nav.show();
	}



	/************************************
	   FREEFORM - AJAX SUBMISSION
	************************************/

	$("form#contact-form, form#booking-form, form#mailing_address_update_form").on('submit', function(e) {
		var $self = $(this);
		$(".alert.alert-success").remove();
		$("button[type=submit]", $self).prop("disabled", true);
		$.ajax({
			type: "post",
			dataType: "json",
			data: $(this).serialize(),
			success: function (response) {
				$("span.errors.help-block", $self).remove();
				$(".has-error", $self).removeClass("has-error");
				if (response.success && response.finished) {
					$self[0].reset();
					var $successMessage = $("<div>", {"class": "alert alert-success"})
						.append("<p>Thank you, form submitted successfully</p>", {"class": "lead"});
					$self.find('h2.form-title').after($successMessage);
				} else if (response.errors) {
					for (var key in response.errors) {
						if (!response.errors.hasOwnProperty(key)) continue;
						var messages = response.errors[key];
						var $errors  = $("<span>", {"class": "errors help-block"});
						for (var i = 0; i < messages.length; i++) {
							$errors.append(messages[i]);
						}
						var $input = $("*[name=" + key + "], *[name='" + key + "[]']");
						$input.siblings("label").append($errors);
					}
				}
				$("button[type=submit]", $self).prop("disabled", false);
			}
		});
		e.preventDefault();
		return false;
	});
	
	
	
	/************************************
	   Social Share Popup
	   https://www.cssscript.com/create-social-share-popup-box-with-pure-javascript-needsharebutton/
	************************************/	
	if($('#share-article').length) {
		new needShareDropdown(document.getElementById('share-article'), {

			// child selector of custom share button
			shareButtonClass: false, 

			// default or box
			iconStyle: 'box', 

			// horizontal or vertical
			boxForm: 'horizontal', 

			// top / middle / bottom + Left / Center / Right
			position: 'topCenter', 

			// text for trigger button
			buttonText: 'Share',

			// http or https
			protocol: ['http', 'https'].indexOf(window.location.href.split(':')[0]) === -1 ? 'https://' : '//',

			// social networks
			networks: 'Facebook,Twitter,GooglePlus,Linkedin,Mailto'

		});
	}
	
	
	/************************************
		ADDRESS FORM MODAL
	************************************/
	
	var lastFocus;
	
	function onPopupClose(){
		Cookies.set('ctfn_address_form_modal_shown', 'yes', { expires: 2 });
		lastFocus.focus();
	}

	function displayPopup(){
		$.fancybox.open({
			src  : '#address-form-modal',
			opts : {
				afterClose: onPopupClose
			}
		});
	}

	setTimeout(function(){
		var popupShown = Cookies.get('ctfn_address_form_modal_shown');
		if(popupShown){
			console.log("Cookie found. No action necessary");
		} else {
			lastFocus = document.activeElement;
			displayPopup();
		}
	}, 5000);
	
	
});




